import * as React from "react";
import Confirm from "components/dialog/confirm";
import { formatMessage } from "lib/globalize-util";
import { TextField } from "material-ui";
import { DATATEST } from "constants/integration";
interface IProps {
    isDeleteConfirmationOpen: boolean;
    onConfirm: () => void;
    onConfirmClose: () => void;
}

export const DeleteConfirmModal: React.FunctionComponent<IProps> = ({
    isDeleteConfirmationOpen,
    onConfirm,
    onConfirmClose,
}) => {
    const boldStyle = React.useMemo(
        () => ({
            display: "inline-bloack",
            marginLeft: "5px",
        }),
        []
    );

    const [confirmText, setConfirmText] = React.useState("");

    const handleDisabledConfirm = React.useCallback((e) => {
        setConfirmText(e.target.value);
    }, []);

    const handleConfirm = React.useCallback(
        (e) => {
            setConfirmText("");
            onConfirm();
        },
        [onConfirm]
    );

    const handleConfirmClose = React.useCallback(
        (e) => {
            setConfirmText("");
            onConfirmClose();
        },
        [onConfirmClose]
    );

    return (
        <Confirm
            title={formatMessage("Delete Assortment")}
            open={isDeleteConfirmationOpen}
            onConfirm={handleConfirm}
            onCancel={handleConfirmClose}
            disabledConfirm={confirmText.toLowerCase() !== "delete"}
        >
            <p>
                {formatMessage(
                    "This will permanently delete the assortment for ALL USERS. This action cannot be undone. Are you sure you want to delete this assortment?"
                )}
            </p>
            <TextField
                data-test={DATATEST.ASSORTMENTS.CONFIRM_DELETE_INPUT}
                hintText={formatMessage("Type 'DELETE' to confirm.")}
                value={confirmText}
                onChange={handleDisabledConfirm}
            />
        </Confirm>
    );
};
